import useAppSelector from '../../../hooks/useAppSelector'
import { getUpdatesOursSelector } from '../dataSlice'

export function useUnsyncedUpdates() {
  return useAppSelector(getUpdatesOursSelector).filter(x => !x.synced)
}
